export default {
    head() {
        let config = {
            meta: []
        }


        if (this.SEO) {
            const { title, description, image, index, follow, canonical, type, options, scripts, publishedTime, modifiedTime, author } = this.SEO
            const ogType = type || "website"

            // og:type
            config.meta.push({ hid: "og:type", property: "og:type", content: ogType })

            if (title) {
                config.title = title
                config.meta.push({ hid: "title", name: "title", content: title })
                config.meta.push({ hid: "og:title", property: "og:title", content: title })
                config.meta.push({ hid: "twitter:title", name: "twitter:title", content: title })
            }

            if (description) {
                config.description = description
                config.meta.push({ hid: "description", name: "description", content: description })
                config.meta.push({ hid: "og:description", property: "og:description", content: description })
                config.meta.push({ hid: "twitter:description", name: "twitter:description", content: description })
            }

            if (image) {
                config.meta.push({ hid: "og:image", property: "og:image", content: image })
                config.meta.push({ hid: "twitter:card", name: "twitter:card", content: "summary_large_image" })
                config.meta.push({ hid: "twitter:image", name: "twitter:image", content: image })
            } else {
                config.meta.push({ hid: "twitter:card", name: "twitter:card", content: "summary" })
            }

            // `follow: true` gives the third state "noindex, follow" — keep the page out
            // of search results but let Google keep crawling its links. Used by the
            // dealer/parts catalogue pages, which link back to customer categories.
            // Omitting `follow` preserves the old "noindex, nofollow" for account /
            // cart / checkout pages, where the links are worth nothing to a crawler.
            if (index === false) {
                config.meta.push({
                    hid: "robots",
                    name: "robots",
                    content: follow ? "noindex, follow" : "noindex, nofollow"
                })
            }

            if (index === true) {
                config.meta.push({ hid: "robots", name: "robots", content: "index, follow" })
            }

            if (canonical) {
                const path = canonical.startsWith('/') ? canonical : `/${canonical}`
                const href = `https://${this.$config.website.domain}${path}`
                config.link = [...(config.link || []), { rel: 'canonical', href }]
                config.meta.push({ hid: "og:url", property: "og:url", content: href })
            } else {
                const href = `https://${this.$config.website.domain}${this.$route.path}`
                config.meta.push({ hid: "og:url", property: "og:url", content: href })
            }

            // article:* OG meta — only when type === "article" and the field is set.
            // Non-blog pages pass nothing and remain unaffected.
            if (ogType === "article") {
                if (publishedTime) {
                    config.meta.push({ hid: "article:published_time", property: "article:published_time", content: publishedTime })
                }
                if (modifiedTime) {
                    config.meta.push({ hid: "article:modified_time", property: "article:modified_time", content: modifiedTime })
                }
                if (author) {
                    config.meta.push({ hid: "article:author", property: "article:author", content: author })
                }
            }

            if (options) {
                const { link: optionsLink, ...restOptions } = options
                Object.assign(config, restOptions)
                if (optionsLink) {
                    config.link = [...(config.link || []), ...optionsLink]
                }
            }

            if (scripts?.length) {
                config.script = scripts
                config.__dangerouslyDisableSanitizers = ["script"]
            }
        }

        return config
    }
}